import axios from "axios";
import { basicURL } from "../../apiManager/APIConfig";
import { CallAPI } from "../../apiManager/ApiCall";
import { aiAskURL, aiGenerateQuestionURL, aiThreadMessagesURL } from "../../apiManager/APIConfig";
import { store } from "../store";

/**
 * Generate a quiz question suggestion using AI.
 * @param {{ prompt?: string, title?: string, slide_context?: string, question_type?: string }} payload
 * @returns {Promise<{ question_content: string, title: string, difficulty: string, answers: Array<{ answer_text: string, is_correct: boolean }> }>}
 */
export const generateQuestionCall = (payload) =>
  CallAPI({
    url: aiGenerateQuestionURL,
    method: "POST",
    body: {
      prompt: payload.prompt || "",
      title: payload.title || "",
      slide_context: payload.slide_context || "",
      question_type: payload.question_type || "text_only",
    },
  });

export const askAIChatCall = async (formData, setProgress = () => {}) => {
  const access_token = store.getState().auth?.access_token;
  const authHeader = access_token?.startsWith("Bearer ")
    ? access_token
    : `Bearer ${access_token}`;

  const response = await axios.post(`${basicURL}${aiAskURL}`, formData, {
    headers: {
      Authorization: authHeader,
    },
    onUploadProgress: (progressEvent) => {
      if (progressEvent?.total) {
        setProgress(progressEvent.loaded / progressEvent.total);
      }
    },
  });
  return response?.data;
};

export const getAIMessagesByThreadCall = (threadId) =>
  CallAPI({
    url: `${aiThreadMessagesURL}/${threadId}/messages`,
    method: "GET",
  });

export const getAllAIThreadsCall = (locale = "en") =>
  CallAPI({
    url: `${aiThreadMessagesURL}/my?locale=${encodeURIComponent(locale)}`,
    method: "GET",
  });
